import { usePartnerContext } from '../context'
import { replaceMacros } from '../helpers'
import { useMailTemplateConstants } from './use-mail-template-constants'

// expiresAt ersetzt in der Vorschau das Fristende einer neuen Einladung
export const useMailTemplates = ({ career, isCrossmode, expiresAt }) => {
  const { partner } = usePartnerContext()

  const {
    mailTemplateLanguage,
    getDefaultMailTemplate,
    getDefaultReminderMailTemplate,
    getDefaultRejectMailTemplate,
    getMailTemplateMacros,
    getMailTemplateMacrosReminder,
    getMailTemplateMacrosReject,
    getMailTemplateSubjectMacros
  } = useMailTemplateConstants({ career, isCrossmode, expiresAt })

  const mailTemplateSubjectMacros = getMailTemplateSubjectMacros()

  const saveParse = (str) => {
    let template = null

    try {
      template = JSON.parse(JSON.stringify(str))
      return template
    } catch (err) {
      // console.error(err)
      return null
    }
  }

  const getMailTemplate = () => {
    let template = null

    if (career) {
      template = saveParse(career.app_settings?.mail_template)
    } else if (isCrossmode) {
      template = saveParse(getDefaultMailTemplate())
    } else {
      template = saveParse(partner.app_settings?.mail_template)
    }

    template = template || JSON.parse(JSON.stringify(getDefaultMailTemplate()))

    template.imageUrl = career?.logo || partner.logo
    template.language = mailTemplateLanguage
    template.useInvitationBlock = true
    // Typ und Stelle für die Test-Mail (sendTestMail), wie bei inviteTalent
    template.emailTemplate = !career && isCrossmode ? 'unlock' : 'invite'
    template.careerId = career?.id

    template.subject = replaceMacros({
      macros: mailTemplateSubjectMacros,
      text: template.subject
    })

    return template
  }

  const getMailTemplateReminder = () => {
    let template = null

    if (career) {
      template = saveParse(career.app_settings?.mail_template_reminder)
    } else {
      template = saveParse(partner.app_settings?.mail_template_reminder)
    }

    template =
      template || JSON.parse(JSON.stringify(getDefaultReminderMailTemplate()))

    template.imageUrl = career?.logo || partner.logo
    template.language = mailTemplateLanguage
    template.useInvitationBlock = true
    template.emailTemplate = 'remind'
    template.careerId = career?.id

    template.subject = replaceMacros({
      macros: mailTemplateSubjectMacros,
      text: template.subject
    })

    return template
  }

  const getMailTemplateReject = () => {
    let template = null

    if (career) {
      template = saveParse(career.app_settings?.mail_template_reject)
    } else {
      template = saveParse(partner.app_settings?.mail_template_reject)
    }

    template =
      template || JSON.parse(JSON.stringify(getDefaultRejectMailTemplate()))

    template.imageUrl = career?.logo || partner.logo
    template.language = mailTemplateLanguage
    template.useInvitationBlock = false
    template.emailTemplate = 'reject'
    template.careerId = career?.id

    template.subject = replaceMacros({
      macros: mailTemplateSubjectMacros,
      text: template.subject
    })

    return template
  }

  const mailTemplate = getMailTemplate()
  const mailTemplateReminder = getMailTemplateReminder()

  // Nutzt die Einladung oder die Erinnerung einen Namen, muss er beim Einladen
  // angegeben werden. Sonst steht in der Erinnerung später eine leere Anrede.
  const usesMacro = (macro) =>
    [mailTemplate, mailTemplateReminder].some(({ data }) =>
      String(data || '').includes(macro)
    )
  mailTemplate.has_firstname_macro = usesMacro('{{firstname}}')
  mailTemplate.has_lastname_macro = usesMacro('{{lastname}}')

  return {
    mailTemplateMacros: getMailTemplateMacros(),
    mailTemplateMacrosReminder: getMailTemplateMacrosReminder(),
    mailTemplateMacrosReject: getMailTemplateMacrosReject(),
    mailTemplate,
    mailTemplateReminder,
    mailTemplateReject: getMailTemplateReject()
  }
}
